/* global google */

import SnazzyInfoWindow from 'snazzy-info-window';
import axios from 'axios';
import mapStyle from '../../../src/js/modules/map-style';
import mapZoomControl from '../../../src/js/modules/map-zoom-control';

const body = document.querySelector('body');
const theme = body.getAttribute('js-theme');
const markerUrl = body.getAttribute('js-marker-icon');

export const markerIcon = {
  url: markerUrl,
  size: new google.maps.Size(40, 57)
};

const mapOptions = {
  styles: mapStyle,
  disableDefaultUI: true,
  scrollwheel: false
};

const setMarkers = (map, bounds, brandColor) => {
  axios.get(getEndpoint()).then(locations => {
    const locationData = locations.data.data;
    for (let i = 0; i < locationData.length; i += 1) {
      const location = locationData[i];
      if (location.lat && location.lng && location.searchEnable) {
        const position = new google.maps.LatLng(location.lat, location.lng);
        bounds.extend(position);
        const marker = new google.maps.Marker({
          position,
          map,
          icon: markerIcon,
          title: location.title
        });

        let labelColor;
        if (theme === 'black') {
          labelColor = 'o-secondary';
        } else {
          labelColor = `o-color-${brandColor}`;
        }

        const content = `
          <div class="info-window">
            <div class="info-window__container">
              <h3 class="o-body">${location.title}</h3>
              <p class="o-caption o-secondary">
                ${location.address}<br />
                ${location.city} ${location.postcode}
              </p>
              <a href="${location.url}" class="o-button ${labelColor}">
                Learn more
              </a>
            </div>
            <div class="info-window__arrow"></div>
          </div>
        `;

        const infowindow = new SnazzyInfoWindow({
          marker,
          showCloseButton: false,
          shadow: false,
          content,
          closeWhenOthersOpen: true,
          offset: {
            top: '-68px'
          }
        });

        google.maps.event.addListener(marker, 'click', () => {
          infowindow.open(map, marker);
        });
      }

      map.fitBounds(bounds);
    }
  });
};

const locationGoogleMaps = async () => {
  const mapElement = document.querySelector('#location-list-map');
  const brandColor = body.getAttribute('js-brand-color');
  if (mapElement) {
    const map = new google.maps.Map(mapElement, mapOptions);
    const bounds = new google.maps.LatLngBounds();
    mapZoomControl(map, brandColor);
    setMarkers(map, bounds, brandColor);
  }
};

const getEndpoint = () => {
  const currentSection = document
      .querySelector('#location-list')
      .getAttribute('js-location-list');

  let api;

  if (currentSection === 'allResidential') {
    api = '/api/residential-for-map.json';
  } else if (currentSection === 'allHotpods') {
    api = '/api/hotpods-for-map.json';
  } else if (currentSection === 'allVirtualOffices') {
    api = '/api/virtual-offices-for-map.json';
  } else if (currentSection === 'allIndustrialUnits') {
    api = '/api/industrial-units-for-map.json';
  }else {
    api = '/api/locations-for-map.json';
  }

  return api;
}

export default locationGoogleMaps;
